import { useCallback } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Publish } from "@mui/icons-material";
import { LoadingComponent } from "../../../helpers";
import { ValidationErrorsContext } from "../../ImportTable/ImportTable/shared/hooks/ValidationErrorsContext";
import { JobFormFields } from "../../shared/JobFormFields";
import JobMap from "../../../helpers/JobMap";
import type { BoundsPadding } from "../../../helpers/JobMap/JobMap.types";
import { useSingleImportFormViewModel } from "./SingleImportForm.vm";
import { ManualEntryFormProps } from "./SingleImportForm.types";
import "./SingleImportForm.css";

const MAP_BOUNDS_PADDING: BoundsPadding = { top: 20, right: 20, bottom: 20, left: 20 };

export function SingleImportForm(props: ManualEntryFormProps) {
	const vm = useSingleImportFormViewModel(props);

	const onGeometryEdit = useCallback(
		(_jobId: string, jsonKey: string, updated: unknown) => {
			vm.updateJobFiles(jsonKey, updated);
		},
		[vm.updateJobFiles],
	);

	return (
		<div className="manual-entry-form">
			{vm.loading && (
				<Box className="loading-overlay">
					<LoadingComponent />
					<Typography variant="h5">Submitting Job...</Typography>
				</Box>
			)}
			<ValidationErrorsContext.Provider value={vm.localValidationErrors}>
				<Box sx={{ display: "flex", gap: 2, minHeight: 400 }}>
					{/* Form Fields - Left Side */}
					<Box sx={{ flex: "0 0 60%", overflowY: "auto", pr: 2, pt: 1 }}>
						<JobFormFields
							job={vm.currentJob}
							columnContext={vm.columnContext}
							dropdownOptions={vm.dropdownOptions}
							branches={vm.branches}
							isVisible={vm.isVisible}
						/>
					</Box>
					{/* Map Preview - Right Side */}
					<Box sx={{ flex: 1, minWidth: 0, borderLeft: 1, borderColor: "divider", pl: 2 }}>
						<JobMap
							onSelectedFeaturesChange={(ids) => console.log("ON SELECTED CHANGE", Array.from(ids))}
							onGeometryEdit={vm.isSuperUser ? onGeometryEdit : undefined}
							job={vm.currentJob}
							height="100%"
							colorMode="layer-type"
							showEmptyState
							disableDefaultUI
							zoomControl
							boundsPadding={MAP_BOUNDS_PADDING}
						/>
					</Box>
				</Box>
			</ValidationErrorsContext.Provider>
			<div className="required-fields-note">
				<Typography>
					Fields marked with <span className="required-asterisk">*</span> are required
				</Typography>
			</div>
			<Button fullWidth variant="contained" color="primary" disabled={!vm.isFormValid} onClick={vm.onSubmit}>
				<Publish className="icon-in-button" /> Create Job
			</Button>
		</div>
	);
}
